import type { FaireProductEntity } from "../../entity_types/product";

export const p_a6dm6tkydx: FaireProductEntity = {
  token: "p_a6dm6tkydx",
  type: "product",
  name: 'Mini Tumbled Amethyst Crystals - 36 pcs, .5"',
  brandToken: "b_23c7bc37",
  brandName: "GeoCentral",
  imageUrl:
    "https://cdn.faire.com/fastly/b464cb6674140a97f31932ed5c7d920017945dc7ceb597abd8829a1d5692c277.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/88454fa5670ff25bcc8d49f10f94a748889872f2b1651b734f3970eecda660b4.jpeg",
  ],
  priceDollars: 0.46,
  description:
    "- Amethyst boosts transformation + intuition! \n- Our assortment of mini crystals are .5” And perfect for carrying in a small bag, keeping in a pocket, or crystal grid making. \n- You will find that the variety and quality of our crystals transform one-item customers into multiple-item collectors! \n- For add-on sales, supplement this new product with bags, crystal grids, and loose tools.\n\nWholesale Crystals | Crystals for Beginners | Introductory Crystals | Souvenir Crystals | Educational Crystals | Geological | Metaphysical | Crystal Properties",
  tags: [],
  msrpDollars: 0.91,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:12.620Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
